import { Component, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-widget-option',
  templateUrl: './option.component.html',
  imports: [
    CommonModule,
  ]
})
export class WidgetOptionComponent {

  /**
   * Option value
   */
  value = input('');

  /**
   * Option is active
   */
  active = input(false);

  /**
   * Clicked event
   */
  clicked = output<void>();

  /**
   * When option is clicked
   */
  click() {
    this.clicked.emit();
  }
}
